import { render } from "./VideoCallHistory.vue?vue&type=template&id=af22eacc&scoped=true"
import script from "./VideoCallHistory.vue?vue&type=script&lang=js"
export * from "./VideoCallHistory.vue?vue&type=script&lang=js"

import "./VideoCallHistory.vue?vue&type=style&index=0&id=af22eacc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af22eacc"]])

export default __exports__